import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Title from "../../extras/Title";
import Table from "../../extras/Table";
import {
  getExpertWalletHistory,
  particulareExpertHistory,
} from "../../../redux/slice/salarySlice";
import Male from "../../../assets/images/male.png";
import Pagination from "../../extras/Pagination";
import Analytics from "../../extras/Analytics";
import Sign from "../../../assets/images/sign.png";
import With from "../../../assets/images/with.png";
import { ReactComponent as Refund } from "../../../assets/icon/refund.svg";

const ParticularExpertEarnings = () => {
  const { salary, expertWallet, total } = useSelector((state) => state.salary);
  const { setting } = useSelector((state) => state.setting);

  const [data, setData] = useState([]);
  const { state } = useLocation();
  const [transactionType, setTransactionType] = useState("All");
  const transactionTypeData = [
    { value: "1", label: "Credit" },
    { value: "2", label: "Debit" },
  ];
  console.log("state", state);
  const [startDate, setStartDate] = useState("ALL");
  const [endDate, setEndDate] = useState("ALL");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  // const expertId = state?.row?.expert
  //   ? state?.row?.expert?._id
  //   : state?.row?._id;

  // useEffect(() => {
  //   dispatch(particulareExpertHistory(expertId));
  // }, [expertId]);
  useEffect(() => {
    const payload = {
      startDate: startDate === "ALL" ? "All" : startDate,
      endDate: endDate === "ALL" ? "All" : endDate,
      start: page,
      limit: rowsPerPage,
      expertId: state?.row?._id,
      type: transactionType,
    };
    dispatch(getExpertWalletHistory(payload));
  }, [startDate, endDate, page, state?.row?._id, transactionType]);

  useEffect(() => {
    setData(expertWallet);
  }, [expertWallet]);

  const dispatch = useDispatch();

  function openHistory(imageUrl) {
    window.open(imageUrl, "_blank");
  }
  const navigate = useNavigate();
  const handleInfo = (id) => {
    navigate("/admin/user/userProfile", {
      state: {
        id,
      },
    });
  };
  const mapData = [
    {
      Header: "No",
      Cell: ({ index }) => <span>{parseInt(index) + 1}</span>,
    },

    {
      Header: "UniqueId",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.uniqueId || "-"}</span>
      ),
    },
    {
      Header: `Amount (${setting?.currencySymbol})`,
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.amount || "-"}</span>
      ),
    },
    {
      Header: `Date`,
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.date || "-"}</span>
      ),
    },
    {
      Header: "Time",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.time ? row?.time : "-"}</span>
      ),
    },

    {
      Header: "Transaction Type",
      Cell: ({ row }) => {
        const isCredit = row?.type === 1;
        const isDebit = row?.type === 2 && row?.payoutStatus === 2;

        return isCredit ? (
          <button
            className="badge-success"
          >
            Credit
          </button>
        ) : isDebit ? (
          <button
            className="badge-danger"
          >
            Debit
          </button>
        ) : (
          <button
            className="badge-warning">
            Pending
          </button>
        );
      },
    },
    {
      Header: "Transaction Completed",
      Cell: ({ row }) => {
        const isCredit = row?.type === 1;
        const isDebit = row?.type === 2;

        return isCredit ? (
          <button
            className="badge-success"

          >

            Booking Complete
          </button>
        ) : isDebit ? (
          <>
            {row?.payoutStatus === 1 ? (
              <button
                className="badge-warning"

              >


                {(row?.payoutStatus === 1 && "Withdraw Pending") ||
                  (row?.payoutStatus === 2 && "Withdraw Approve") ||
                  (row?.payoutStatus === 3 && "Withdraw Declined")}

              </button>
            ) : (
              <button
                className="badge-info"

              >


                {(row?.payoutStatus === 1 && "Withdraw Pending") ||
                  (row?.payoutStatus === 2 && "Withdraw Approve") ||
                  (row?.payoutStatus === 3 && "Withdraw Declined")}

              </button>
            )}
          </>
        ) : (
          ""
        );
      },
    },
  ];

  return (
    <>
      <div className="userPage">
        <div className="d-flex justify-content-end mb-3">
          <Analytics
            analyticsStartDate={startDate}
            analyticsStartEnd={endDate}
            placeholder="Wallet"
            analyticsStartDateSet={setStartDate}
            analyticsStartEndSet={setEndDate}
          />
        </div>
        <div className="user-table mb-3">
          <div className="user-table-top">
            <div className=" d-flex justify-content-between align-items-center w-100 ">
              <div className="w-100">
                <h5 className="main-title">
                  {state?.row?.expert
                    ? state?.row?.expert?.fname +
                    " " +
                    state?.row?.expert?.lname
                    : state?.row?.fname + " " + state?.row?.lname}
                  's Income Details
                </h5>
              </div>
              <div className="d-flex gap-2 justify-content-end w-100">
                <div className="inputData w-25 ">
                  <select
                    name="transactionType"
                    className="form-select "
                    id="transactionType"
                    value={transactionType}
                    onChange={(e) => {
                      console.log("eeeeee", e);
                      const selectedSalonId = e.target.value;
                      const payload = {
                        startDate: startDate === "ALL" ? "All" : startDate,
                        endDate: endDate === "ALL" ? "All" : endDate,
                        start: page,
                        limit: rowsPerPage,
                        expertId: state?.row?._id,
                        type: transactionType,
                      };
                      setTransactionType(selectedSalonId);
                      dispatch(getExpertWalletHistory(payload));
                    }}
                  >
                    <option key="All" value="All">
                      ALL
                    </option>
                    {transactionTypeData?.map((data) => (
                      <option key={data?.value} value={data?.value}>
                        {data?.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <Table data={data} mapData={mapData} />
          <Pagination
            type={"server"}
            serverPage={page}
            setServerPage={setPage}
            serverPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalData={total}
          />
        </div>
        {/* <Title
        name={`${state?.row?.expert
          ? state?.row?.expert?.fname + " " + state?.row?.expert?.lname
          : state?.row?.fname + " " + state?.row?.lname
          }'s Income Details`}
      /> */}

        <div>
          {/* <div className="betBox">
            <div className="col-md-9">
              <div className="inputData">
                <label>Analytic</label>
              </div>
              <Analytics
                analyticsStartDate={startDate}
                analyticsStartEnd={endDate}
                placeholder="Wallet"
                analyticsStartDateSet={setStartDate}
                analyticsStartEndSet={setEndDate}
              />
            </div>
          </div> */}

        </div>
      </div>
    </>
  );
};

export default ParticularExpertEarnings;
